export default __webpack_public_path__ + "static/media/030-html-5.169ecb56.svg";